export class PatternCase {
    static WEEKEND_PATTERN = 'weekendPatterns';
    static WISH_PATTERN = 'wishPatterns';
    static VACATION = 'vacationPatterns';
    static HOLIDAY_PATTERN = 'holidayPatterns';
    static PAID_LEAVE_PATTERN = 'paidLeavePatterns';
    static ALL_PATTERNS =
        '?includeWeekendPatterns=true' +
        '&includeWishPatterns=true' +
        '&includeVacationPatterns=true' +
        '&includeHolidayPatterns=true' +
        '&includePaidLeavePatterns=true';

    static translate(patternCase: string): string {
        switch (patternCase) {
            case this.WEEKEND_PATTERN:
                return 'Helg';
            case this.WISH_PATTERN:
                return 'Annet fravær';
            case this.VACATION:
                return 'Ferie';
            case this.HOLIDAY_PATTERN:
                return 'Helligdag';
            case this.PAID_LEAVE_PATTERN:
                return 'Permisjon';
            default:
                return 'Fravær';
        }
    }
}
